import * as yup from "yup";

const adminSchema = yup.object().shape({
    email: yup.string().email("Invalid email format").required("Required"),
    password: yup.string().required("Required"),
});

export default adminSchema;
